module.exports = __webpack_public_path__ + "media/images/bonusForSharing__bg-75ee66ca93a29f5098c3e687bbbe4a5b.jpg";